<div class="indicator is-{{ status }}" [ngSwitch]="status">
  <ng-container *ngSwitchCase="'draft'">Draft</ng-container>
  <ng-container *ngSwitchCase="'scheduled'">Scheduled</ng-container>
  <ng-container *ngSwitchCase="'published'">Published</ng-container>
  <ng-container *ngSwitchCase="'failed'">Failed</ng-container>
</div>
